import AsyncStorage from '@react-native-async-storage/async-storage';

import {
  GET_CABYS_CATALOG,
  TypesActionsSettings,
  GetCabysCatalogArgs,
  LATSEST_CABYS_CODES,
  GET_ECONOMIC_ACTIVITY_CATALOG,
  GET_ECONOMIC_ACTIVITY_RESTAURANT,
  LatestCabysCodesArgs,
  GetEconomicActivityRestaurantgArgs,
  RESET_SETTINGS_STATE,
  GET_SETTINGS,
  GetSettings,
} from './SettingTypes';
import {
  CabysCatalog,
  LatestCabysCodes,
  EconomicActivity,
  Setting,
} from '../../../types/settings/Setting';
import { SettingsDao } from '../../../api/settings/dao/settings.dao';

function getCatalogCabys(payload: CabysCatalog[]): TypesActionsSettings {
  return {
    type: GET_CABYS_CATALOG,
    payload,
  };
}

function getLatestCabysCodes(
  payload: LatestCabysCodes[]
): TypesActionsSettings {
  return {
    type: LATSEST_CABYS_CODES,
    payload,
  };
}

function getEconomicActivityCatalog(
  payload: EconomicActivity[]
): TypesActionsSettings {
  return {
    type: GET_ECONOMIC_ACTIVITY_CATALOG,
    payload,
  };
}

function getEconomicActivityRestaurant(
  payload: EconomicActivity[]
): TypesActionsSettings {
  return {
    type: GET_ECONOMIC_ACTIVITY_RESTAURANT,
    payload,
  };
}

export function resetSettingsState(): TypesActionsSettings {
  return {
    type: RESET_SETTINGS_STATE,
  };
}

function getSettings(payload: Setting): TypesActionsSettings {
  return {
    type: GET_SETTINGS,
    payload,
  };
}

export function getCabysCatalogAsync({
  callbackPre,
  callbackSuccess,
  callbackError,
}: GetCabysCatalogArgs) {
  return async function (dispacth: Function) {
    try {
      if (callbackPre && typeof callbackPre === 'function') {
        callbackPre();
      }
      const response = await SettingsDao.getCatalogCabys();
      dispacth(getCatalogCabys(response.data));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError();
      }
      console.log(error);
    }
  };
}

export function getLatestCabysCodesAsync({
  accountId,
  callbackPre,
  callbackSuccess,
  callbackError,
}: LatestCabysCodesArgs) {
  return async function (dispacth: Function) {
    try {
      if (callbackPre && typeof callbackPre === 'function') {
        callbackPre();
      }
      const response = await SettingsDao.getLatestCabysCodes(accountId);
      dispacth(getLatestCabysCodes(response.data));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError();
      }
      console.log(error);
    }
  };
}

export function getEconomicActivityCatalogAsync({
  callbackPre,
  callbackSuccess,
  callbackError,
}: GetCabysCatalogArgs) {
  return async function (dispacth: Function) {
    try {
      if (callbackPre && typeof callbackPre === 'function') {
        callbackPre();
      }
      const response = await SettingsDao.getEconomicActivities();
      dispacth(getEconomicActivityCatalog(response.data));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError();
      }
      console.log(error);
    }
  };
}

export function getEconomicActivityRestaurantAsync({
  user,
  callbackPre,
  callbackSuccess,
  callbackError,
}: GetEconomicActivityRestaurantgArgs) {
  return async function (dispacth: Function) {
    console.log('Economic Activity Restaurant', user);
    try {
      if (
        user &&
        user.settings &&
        user.settings.economicActivityCode &&
        Array.isArray(user.settings.economicActivityCode) &&
        user.settings.economicActivityCode.length
      ) {
        console.log(
          'Economic Activity Code',
          user.settings.economicActivityCode
        );
        const response = await SettingsDao.getEconomicActivities();
        
        // Limpiar códigos: solo eliminar espacios, mantener decimales (.0, .1, .2, etc)
        const cleanCode = (code: string): string => {
          if (!code) return '';
          return String(code).trim();
        };
        
        const codesSet = new Set(
          user.settings.economicActivityCode.map((code) => cleanCode(String(code)))
        );
        
        console.log('Codes from settings:', Array.from(codesSet));
        console.log('Total activities from API:', response.data?.length || 0);
        
        const auxOptions = response.data?.filter((option) => {
          const codigoDGTCIIU3 = cleanCode(String(option.codigoDGTCIIU3 || ''));
          const codigoSubClaseCIIU4 = cleanCode(String(option.codigoSubClaseCIIU4 || ''));
          const matches = codesSet.has(codigoDGTCIIU3) || codesSet.has(codigoSubClaseCIIU4);
          if (matches) {
            console.log('Matched activity:', {
              codigoDGTCIIU3: option.codigoDGTCIIU3,
              codigoSubClaseCIIU4: option.codigoSubClaseCIIU4,
              cleaned: { codigoDGTCIIU3, codigoSubClaseCIIU4 },
              settingCodes: Array.from(codesSet)
            });
          }
          return matches;
        });
        
        // Si hay duplicados por codigoSubClaseCIIU4, dejar solo uno
        const uniqueBySubClase = new Map();
        auxOptions?.forEach((option) => {
          const codigoSubClaseCIIU4 = cleanCode(String(option.codigoSubClaseCIIU4 || ''));
          if (codigoSubClaseCIIU4 && !uniqueBySubClase.has(codigoSubClaseCIIU4)) {
            uniqueBySubClase.set(codigoSubClaseCIIU4, option);
          }
        });
        
        const finalOptions = Array.from(uniqueBySubClase.values());
        
        console.log('Filtered activities count (before deduplication):', auxOptions?.length || 0);
        console.log('Filtered activities count (after deduplication):', finalOptions.length);
        dispacth(getEconomicActivityRestaurant(finalOptions));
        console.log('Economic Activity Restaurant', auxOptions);
      }
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError();
      }
      console.log(error);
    }
  };
}

export function getSettingsAsync({
  accountId,
  callbackError,
  callbackSuccess,
}: GetSettings) {
  return async function (dispacth: Function) {
    try {
      const response = await SettingsDao.list(accountId);
      if (response.data && response.data.length > 0) {
        dispacth(getSettings(response.data[0]));
      }
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError();
      }
      console.log(error);
    }
  };
}
